var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"list-header",class:{ 'centered-text': _vm.centeredText },style:(_vm.numberOfColumns)},_vm._l((_vm.headerElements),function(header,index){return _c('p',{key:header.id,class:{ 'no-wrap': _vm.isProductSegmentation && index === 0 }},[_vm._v(" "+_vm._s(header)+" ")])}),0),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }